var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"alert",class:_vm.error ? 'alert-danger' : 'alert-success',attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }